module.exports = {
  dmp: [
    {
      heading: "Specialties",
      contents: [
        {
          description:
            "Browse and follow our evidence-driven and continually updated topics by specialty.",
        },
      ],
      action: {
        type: "button",
        text: "Browse Specialties",
        route: "/browse/specialties",
      },
      imageSrc: {
        landscape:
          "https://resources.dynamed.com/discover.medical.dynamedui/assets/images/Specialties_med.jpg",
        portrait:
          "https://resources.dynamed.com/discover.medical.dynamedui/assets/images/Specialties.jpg",
      },
    },

    {
      heading: "Drug Resources",
      contents: [
        {
          action: {
            type: "link",
            text: "Drugs A-Z",
            route: "/browse/drug-monograph",
          },
          description: "Drug monographs from Merative Micromedex<sup>®</sup>.",
        },
        {
          action: {
            type: "link",
            text: "Drug Interaction Checker",
            route: "/browse/drug-interactions",
            gated: true,
          },
          description:
            "Learn how two or more drugs interact and keep your patients safe.",
        },
      ],
      imageSrc: {
        landscape:
          "https://resources.dynamed.com/discover.medical.dynamedui/assets/images/Drug_Resources_med.jpg",
        portrait:
          "https://resources.dynamed.com/discover.medical.dynamedui/assets/images/Drug_Resources.jpg",
      },
    },
    {
      heading: "Go Mobile",
      contents: [
        {
          description:
            "Our <strong>iOS & Android apps are FREE for use</strong> by all subscribers.",
        },
      ],
      action: { type: "button", text: "Get the App", route: "/mobile" },
      imageSrc: {
        icon:
          "https://resources.dynamed.com/discover.medical.dynamedui/assets/images/DynaMed_app.svg",
      },
    },
  ],
  dmx: [
    {
      heading: "Specialties",
      contents: [
        {
          description:
            "Browse and follow our evidence-driven and continually updated topics by specialty.",
        },
      ],
      action: {
        type: "button",
        text: "Browse Specialties",
        route: "/browse/specialties",
      },
      imageSrc: {
        landscape:
          "https://resources.dynamedex.com/discover.medical.dynamedui/assets/images/Specialties_med.jpg",
        portrait:
          "https://resources.dynamedex.com/discover.medical.dynamedui/assets/images/Specialties.jpg",
      },
    },
    {
      heading: "Drug Resources",
      contents: [
        {
          description:
            "In addition to <strong>NeoFax<sup>®</sup> / Pediatrics</strong>, we offer:",
        },
        {
          action: {
            type: "link",
            text: "Drugs A-Z",
            route: "/browse/drug-monograph",
          },
          description: "Drug monographs from Merative Micromedex<sup>®</sup>.",
        },
        {
          action: {
            type: "link",
            text: "Drug Interaction Checker",
            route: "/?watsonLaunch=drugInteraction",
            gated: true,
          },
          description:
            "Learn how two or more drugs interact and keep your patients safe.",
        },
        {
          action: {
            type: "link",
            text: "IV Compatibility",
            route: "/?watsonLaunch=ivCompatibility",
            gated: true,
          },
        },
      ],
      imageSrc: {
        landscape:
          "https://resources.dynamedex.com/discover.medical.dynamedui/assets/images/Drug_Resources_med.jpg",
        portrait:
          "https://resources.dynamedex.com/discover.medical.dynamedui/assets/images/Drug_Resources.jpg",
      },
    },
    {
      heading: "Go Mobile",
      contents: [
        {
          description:
            "Our <strong>iOS & Android apps are FREE for use</strong> by all subscribers.",
        },
      ],
      action: { type: "button", text: "Get the App", route: "/mobile" },
      imageSrc: {
        icon:
          "https://resources.dynamedex.com/discover.medical.dynamedui/assets/images/DynaMedex_app_icon.svg",
      },
    },
  ],
};
